import { useState } from 'preact/hooks';
import { scStyles } from './styles';
import type { SkillMeta } from './types';
import { T } from '../../styles/tokens';
import { Button } from '../ui';

interface Props {
  skill: SkillMeta;
  index?: number;
  onDetails?: (skill: SkillMeta) => void;
  onInstall?: (skill: SkillMeta) => void;
}

export function SkillCardNew({ skill, index = 0, onDetails, onInstall }: Props) {
  const [hovered, setHovered] = useState(false);

  const getBadge = () => {
    if (skill.tier === 'tier1' || skill.verified) return scStyles.badgeVerified;
    if (skill.tier === 'tier2' || skill.badge === 'recommended') return scStyles.badgeRecommended;
    if (skill.badge === 'new') return scStyles.badgeNew;
    return scStyles.badgeCommunity;
  };

  const getBadgeText = () => {
 if (skill.tier === 'tier1' || skill.verified) return 'Verificada';
 if (skill.tier === 'tier2' || skill.badge === 'recommended') return 'Recomendada';
    if (skill.badge === 'new') return '🆕 Nova';
 return 'Comunidade';
  };

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        ...scStyles.glass,
        padding: '20px',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        animation: `fadeInUp 0.4s ease ${index * 0.05}s both`,
        ...(hovered ? { transform: 'scale(1.02)', boxShadow: `0 8px 32px ${T.purpleBgStrong}` } : {}),
      }}
    >
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'flex-start', gap: '12px', marginBottom: '12px' }}>
 <span style={{ fontSize: '32px', lineHeight: 1 }}>{skill.emoji || ''}</span>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: '15px', fontWeight: 700, color: T.text, marginBottom: '4px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {skill.name}
          </div>
          <span style={getBadge()}>{getBadgeText()}</span>
        </div>
      </div>

      {/* Description */}
      <p style={{ fontSize: '13px', color: T.textSecondary, lineHeight: 1.5, margin: '0 0 12px', display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
        {skill.description_pt || skill.description || 'Sem descrição'}
      </p>

      {/* API Key indicator */}
      {skill.requires_api_key ? (
        <div style={{ fontSize: '11px', color: T.warning, marginBottom: '12px', display: 'flex', alignItems: 'center', gap: '4px' }}>
 Requer: {skill.required_keys || 'API Key'}
        </div>
      ) : (
        <div style={{ fontSize: '11px', color: T.success, marginBottom: '12px' }}>
 Sem API Key necessária
        </div>
      )}

      {/* Actions */}
      <div style={{ display: 'flex', gap: '8px' }}>
        <Button variant="ghost"
          onClick={(e) => { e.stopPropagation(); onDetails?.(skill); }}
          style={{
            flex: 1, padding: '8px 12px', borderRadius: '8px', border: `1px solid ${T.purpleBgStrong}`,
            background: T.purpleBg, color: T.purple, fontSize: '12px', fontWeight: 600,
            cursor: 'pointer', transition: 'all 0.2s',
          }}
        >
          Detalhes
        </Button>
        <Button variant="ghost"
          onClick={(e) => { e.stopPropagation(); onInstall?.(skill); }}
          style={{
            flex: 1, padding: '8px 12px', borderRadius: '8px', border: 'none',
            background: 'linear-gradient(135deg, #7c3aed, #a855f7)', color: T.text, fontSize: '12px', fontWeight: 600,
            cursor: 'pointer', transition: 'all 0.2s',
          }}
        >
          Instalar
        </Button>
      </div>
    </div>
  );
}
